/**
 * Initialize all Swipers
 */

import Swiper from 'swiper/bundle';

export function initSwipers() {
    initUspsSwiper();
    initFooterUspsSwiper();
}

/**
 * Initialize USPs Swiper - Only for mobile (< 768px)
 */
function initUspsSwiper() {
    if (typeof window === 'undefined' || !Swiper) {
        return;
    }

    function initUsps() {
        // Find all USP swipers on the page
        const uspsSwipers = document.querySelectorAll('.usps-swiper');
        
        if (uspsSwipers.length === 0) {
            return;
        }
        
        // Only initialize Swiper on mobile screens (below 768px)
        if (window.innerWidth < 768) {
            uspsSwipers.forEach(function(swiperEl) {
                // Destroy existing instance if any
                if (swiperEl.swiper) {
                    try { 
                        swiperEl.swiper.destroy(true, true);
                    } catch(e) {}
                }
                
                if (Swiper) {
                    try {
                        new Swiper(swiperEl, {
                            slidesPerView: 1,
                            spaceBetween: 16,
                            autoplay: {
                                delay: 3000,
                                disableOnInteraction: false
                            },
                            loop: true
                        });
                    } catch(e) {}
                } else {
                    // graceful fallback: enable horizontal scroll on mobile
                    swiperEl.style.overflowX = 'auto';
                    swiperEl.style.scrollSnapType = 'x mandatory';
                    const slides = swiperEl.querySelectorAll('.swiper-slide');
                    slides.forEach(function(s){
                        s.style.scrollSnapAlign = 'start';
                        s.style.flex = '0 0 80%';
                    });
                }
            });
        } else {
            // On desktop, destroy all Swiper instances
            uspsSwipers.forEach(function(el) {
                if (el.swiper) {
                    try { 
                        el.swiper.destroy(true, true);
                    } catch(e) {}
                }
            });
        }
    }
    
    // Initialize on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initUsps);
    } else {
        initUsps();
    }
    
    // Re-initialize on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initUsps, 250);
    });
}

/**
 * Initialize Footer USPs Swiper
 */
function initFooterUspsSwiper() {
    if (typeof window === 'undefined' || !Swiper) {
        return;
    }

    const footerUspsSwiper = document.getElementById('footer-usps-swiper');
    if (!footerUspsSwiper) {
        return;
    }

    function initFooterUsps() {
        // Only initialize Swiper on mobile screens (below 768px)
        if (window.innerWidth < 768) {
            const footerSwiperEl = document.getElementById('footer-usps-swiper');
            if (Swiper && footerSwiperEl) {
                /* destroy existing instance if any (hot reload safety) */
                if (footerSwiperEl.swiper) {
                    try { footerSwiperEl.swiper.destroy(true, true); } catch(e) {}
                }
                new Swiper('#footer-usps-swiper', {
                    slidesPerView: 1,
                    spaceBetween: 16,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false
                    },
                    loop: true
                });
            }
        } else {
            // On desktop, ensure no Swiper instance exists
            const el = document.getElementById('footer-usps-swiper');
            if (el && el.swiper) {
                try { el.swiper.destroy(true, true); } catch(e) {}
            }
        }
    }
    
    // Initialize on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initFooterUsps);
    } else {
        initFooterUsps();
    }
    
    // Re-initialize on window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(initFooterUsps, 250);
    });
}

